import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';
import { aboutInfo } from '@/mocks/articles';

export default function About() {
  return (
    <>
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: [
            {
              '@type': 'Question',
              name: '这个网站是小野坂唯香官方的吗？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '本站是由华语地区粉丝自发建立和维护的资讯平台，并非小野坂唯香本人或其所属事务所的官方网站。',
              },
            },
            {
              '@type': 'Question',
              name: '网站的内容来源是什么？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '内容主要来自日本官方媒体发布的信息、小野坂唯香官方社交媒体的公开内容，以及经过核实的行业媒体报道。',
              },
            },
            {
              '@type': 'Question',
              name: '如何获取小野坂唯香的最新动态？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '您可以定期访问本站最新动态板块，或关注我们的社交媒体账号（微博、Bilibili）。',
              },
            },
            {
              '@type': 'Question',
              name: '可以转载本站的内容吗？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '欢迎转载，但请注明出处并保留原文链接。商业用途转载需先获得授权。',
              },
            },
            {
              '@type': 'Question',
              name: '如何参与粉丝应援活动？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '请关注粉丝应援板块及我们的社交媒体账号，我们会定期发布应援活动信息。',
              },
            },
          ],
        }}
      />
      <main className="pt-20">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <Breadcrumb items={[{ label: '关于本站' }]} />

            <header className="mb-12">
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                关于本站
              </h1>
              <p className="text-foreground-500 text-sm">{aboutInfo.brandName}</p>
            </header>

            <section className="mb-14">
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">品牌介绍</h2>
              <p className="text-foreground-700 leading-relaxed text-[15px] mb-4">{aboutInfo.introduction}</p>
              <p className="text-foreground-700 leading-relaxed text-[15px]">{aboutInfo.mission}</p>
            </section>

            <section className="mb-14">
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-6">我们的声誉</h2>

              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
                {aboutInfo.achievements.map((item) => (
                  <div
                    key={item.label}
                    className="text-center p-6 rounded-lg bg-background-100 border border-background-200/70"
                  >
                    <p className="font-heading text-2xl md:text-3xl font-bold text-primary-500 mb-1">
                      {item.number}
                    </p>
                    <p className="text-xs text-foreground-500">{item.label}</p>
                  </div>
                ))}
              </div>

              <div className="p-6 rounded-lg bg-background-100 border border-background-200/70">
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-3">我们的价值观</h3>
                <div className="flex flex-wrap gap-3">
                  {aboutInfo.values.map((v) => (
                    <span
                      key={v}
                      className="px-4 py-2 rounded-full text-sm font-medium bg-accent-100 text-accent-700 whitespace-nowrap"
                    >
                      <i className="ri-check-line mr-1.5"></i>{v}
                    </span>
                  ))}
                </div>
              </div>
            </section>

            <section className="mb-14">
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-6">联系我们</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex items-start gap-4 p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 shrink-0">
                    <i className="ri-mail-line"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900 mb-1">电子邮件</p>
                    <p className="text-sm text-foreground-600">{aboutInfo.contact.email}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 shrink-0">
                    <i className="ri-weibo-line"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900 mb-1">微博</p>
                    <p className="text-sm text-foreground-600">{aboutInfo.contact.weibo}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 shrink-0">
                    <i className="ri-bilibili-line"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900 mb-1">Bilibili</p>
                    <p className="text-sm text-foreground-600">{aboutInfo.contact.bilibili}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 shrink-0">
                    <i className="ri-map-pin-line"></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900 mb-1">所在地</p>
                    <p className="text-sm text-foreground-600">{aboutInfo.contact.address}</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-14">
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-6">常见问题</h2>
              <div className="space-y-3">
                {[
                  {
                    q: '这个网站是小野坂唯香官方的吗？',
                    a: '本站是由华语地区粉丝自发建立和维护的资讯平台，并非小野坂唯香本人或其所属事务所的官方网站。我们致力于为华语粉丝提供准确、及时的中文资讯。',
                  },
                  {
                    q: '网站的内容来源是什么？',
                    a: '我们的内容主要来自日本官方媒体发布的信息、小野坂唯香官方社交媒体的公开内容，以及经过核实的行业媒体报道。所有内容均由编辑团队翻译整理，确保信息的准确性和可靠性。',
                  },
                  {
                    q: '如何获取小野坂唯香的最新动态？',
                    a: '您可以定期访问本站"最新动态"板块，或关注我们的社交媒体账号（微博、Bilibili）。我们会在第一时间更新小野坂唯香的最新资讯、演出信息和活动安排。',
                  },
                  {
                    q: '可以转载本站的内容吗？',
                    a: '欢迎转载，但请注明出处并保留原文链接。如需商业用途转载，请先通过电子邮件与我们联系获得授权。',
                  },
                  {
                    q: '如何参与粉丝应援活动？',
                    a: '请关注"粉丝应援"板块及我们的社交媒体账号，我们会定期发布应援活动信息。您也可以通过电子邮件或社交媒体私信联系我们，加入粉丝社群。',
                  },
                ].map((faq, idx) => (
                  <details key={idx} className="group rounded-lg border border-background-200/70 bg-background-50">
                    <summary className="flex items-center justify-between cursor-pointer p-5 text-sm font-medium text-foreground-900">
                      {faq.q}
                      <i className="ri-add-line group-open:hidden text-foreground-400"></i>
                      <i className="ri-subtract-line hidden group-open:block text-foreground-400"></i>
                    </summary>
                    <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </div>
                  </details>
                ))}
              </div>
            </section>
          </div>
        </div>
      </main>
    </>
  );
}